import { Flex, Grid, Group, Stack, Text } from '@mantine/core'
import { MoreInfo } from '@ospace/shared'
import type { CSSProperties } from 'react'

interface Props {
  labelColor?: string
  left: {
    label: string
    value: string | number | any
    tooltip?: string
  }
  right: {
    label: string
    value: string | number | any
    tooltip?: string
  }
  style?: CSSProperties
}

export const SideBySideFigures = ({
  labelColor = 'rgb(73, 80, 87)',
  left: { label: leftLabel, value: leftValue, tooltip: leftTooltip },
  right: { label: rightLabel, value: rightValue, tooltip: rightTooltip },
  ...cssProps
}: Props) => {
  return (
    <Grid gutter={15} c='gray.7' {...cssProps}>
      <Grid.Col span={6}>
        <Stack gap={0}>
          <Group>
            <Text fz='md' c={labelColor}>
              {leftLabel}
            </Text>
            {leftTooltip && <MoreInfo info={leftTooltip} iconColor={labelColor} />}
          </Group>
          <div
            style={{
              fontSize: '28px',
              fontWeight: 700,
              color: labelColor,
              paddingTop: 5,
            }}
          >
            {leftValue}
          </div>
        </Stack>
      </Grid.Col>
      <Grid.Col span={6}>
        <Flex justify='flex-end'>
          <Stack gap={0}>
            <Group>
              <Text fz='md' c={labelColor}>
                {rightLabel}
              </Text>
              {rightTooltip && <MoreInfo info={rightTooltip} iconColor={labelColor} />}
            </Group>
            <Flex justify='flex-end' style={{ paddingTop: 5 }}>
              <div
                style={{
                  fontSize: '28px',
                  fontWeight: 700,
                  color: labelColor,
                  paddingTop: 5,
                }}
              >
                {rightValue}
              </div>
            </Flex>
          </Stack>
        </Flex>
      </Grid.Col>
    </Grid>
  )
}
